import React, { Component } from "react";
import { connect } from "react-redux";
import GoogleMap from "google-map-react";
import { googleMapsStyle } from "../../../../helpers";
import Marker from "./Marker";

let mapVariables = {};

function createMapOptions(maps) {
    return {
        zoomControlOptions: {
            position: maps.ControlPosition.RIGHT_CENTER,
            style: maps.ZoomControlStyle.SMALL
        },
        mapTypeControlOptions: { position: maps.ControlPosition.TOP_RIGHT },
        styles: googleMapsStyle,
        mapTypeControl: true,
        scrollwheel: false
    };
}

class Direction extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    handleDrawDirection({ map, maps }) {
        mapVariables.maps = { map, maps };

        this.calculateAndDisplayRoute();
    }

    calculateAndDisplayRoute() {
        setTimeout(
            () => {

                let { data } = this.props;
                const directionsService = new mapVariables.maps.maps.DirectionsService();

                const directionsDisplay = new mapVariables.maps.maps.DirectionsRenderer(
                    { suppressMarkers: true, polylineOptions: { strokeColor: "#e4202e" } }
                );

                directionsDisplay.setMap(mapVariables.maps.map);

                const startPoint = data.routes.find(
                    trip => trip.type === "StartPoint"
                );

                const endPoint = data.routes.find(
                    trip => trip.type === "EndPoint"
                );

                const waypointArray = data.routes.filter(
                    trip => trip.type === "WayPoint"
                );

                let waypts = [];

                for (let i = 0; i < waypointArray.length; i++) {
                    waypts.push({
                        location: {
                            lat: waypointArray[i].latitude,
                            lng: waypointArray[i].longitude
                        },
                        stopover: true
                    });
                }

                directionsService.route(
                    {
                        origin: { lat: startPoint.latitude, lng: startPoint.longitude },
                        destination: { lat: endPoint.latitude, lng: endPoint.longitude },
                        waypoints: waypts,
                        travelMode: "DRIVING"
                    },
                    function (response, status) {
                        if (status === "OK") {
                            directionsDisplay.setDirections(response);
                        } else {
                            window.alert("Directions request failed due to " + status);
                        }
                    }
                );
            },
            500
        );
    }


    render() {
        let { data } = this.props;

        return (

            <GoogleMap
                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                center={[data.routes[0].latitude, data.routes[0].longitude]}
                yesIWantToUseGoogleMapApiInternals
                zoom={12}
                onGoogleApiLoaded={this.handleDrawDirection.bind(this)}
                style={{ width: 1250, height: 350 }}
                options={createMapOptions}
            >
                {data.routes
                    .filter(point => point.type === "StartPoint")
                    .map((point, i) => (
                        <Marker
                            key={"startMap-" + i}
                            claz="start-point"
                            lat={point.latitude}
                            lng={point.longitude}
                            onClick={this._distanceToMouse} text="1" />
                    ))
                }
                {data.routes
                    .filter(point => point.type === "WayPoint")
                    .map((point, i) => {
                        let index = 2;
                        return (
                            <Marker
                                key={"wayMap-" + i}
                                claz="way-point"
                                lat={point.latitude}
                                lng={point.longitude}
                                text={index + i} />
                        );
                    })
                }
                {data.routes
                    .filter(point => point.type === "EndPoint")
                    .map((point, i) => (
                        <Marker
                            claz="end-point"
                            lat={point.latitude}
                            lng={point.longitude}
                            key={"endMap-" + i}
                            text={data.routes.length + i} />

                    ))
                }
            </GoogleMap>

        );
    }
}

const mapStateToProps = ({ auth }) => ({ auth });
export default connect(mapStateToProps)(Direction);



// WEBPACK FOOTER //
// ./src/components/App/components/GoogleMaps/Direction.js